import { investorApi } from '@core/api/httpClient'
import { WALLET_ENDPOINTS } from './walletEndpointPaths'
import { parseWalletStatus } from './walletParser'
import type { WalletStatus } from '../types/walletTypes'

export async function getWalletStatus(offeringId: string): Promise<WalletStatus> {
  const { data } = await investorApi.post<unknown>(WALLET_ENDPOINTS.OFFERING_READINESS, {
    offeringId,
  })
  return parseWalletStatus(data)
}
